export default __webpack_public_path__ + "static/media/tfg_favicon_white.5d8a7e75.svg";